import React, { Fragment } from "react";
import { Collapse, Popover } from "antd";
import IconTick from "@/components/icons/IconTick";
import IconMinus from "@/components/icons/IconMinus";
import IconViewMore from "@/components/icons/IconViewMore";

import "@/styles/components/membership.scss";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "@/components/button/Button";
import { getProducts } from "@/services/services/getProducts";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsLoggedIn,
  setCurrentForm,
  setFormProps,
  setModalOpen,
} from "@/reducers/commonSlice";
import { setCheckoutType, setIsCheckoutToShow, setProductData } from "@/reducers/checkoutSlice";
import IconInfo from "@/components/icons/IconInfo";
import IconAdd from "@/components/icons/IconAdd";
import { getProductData } from "@/services/common/getProductData";

const Membership = ({ isHomePage = false }) => {
  // const [showAll, setShowAll] = useState(false);
  const customExpandIcon = ({ isActive }) => (isActive ? <IconMinus /> : <IconAdd />);

  const isLoggedIn = useSelector(getIsLoggedIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Panel } = Collapse;

  const FAQ = {
    heading: "FAQ",
    accordion: [
      {
        q: "What are the membership options available?",
        a: "<span>We offer two options : The basic Explorer and the premium Globetrotter</span>",
      },
      {
        q: "How do I become a member?",
        a: "<span>You can sign up for membership through our website. Choose your desired membership option and follow the registration process</span>",
      },
      {
        q: "Is there a fee to join the Explorer membership?",
        a: "<span>No, the Explorer membership is free of charge</span>",
      },
      {
        q: "What are the costs associated with the globetrotter membership?",
        a: "<span>The Globetrotter membership costs, which gives you premium access to benefits tailored to your academic, social and career development needs.</span>",
      },
      {
        q: "Why should I sign up for the globetrotter membership?",
        a: "<span>The Globetrotter membership gives you additional benefits such as personalized career development workshops, networking opportunities, housing assistance and much more, that the Explorer does not offer.</span>",
      },
      {
        q: "What types of job openings are available in the curated list?",
        a: "<span>Our curated list includes both part-time and full-time job opportunities specifically tailored for students, helping you manage expenses while studying</span>",
      },
      {
        q: "What are the career development workshops?",
        a: "<span>The workshops are online and in-person sessions designed to provide you insights into the job market and help enhance your skill set.</span>",
      },
      {
        q: "Do I need to register for the workshops?",
        a: "<span>Yes, you need to register for the workshop. Details will be provided in advance.</span>",
      },
      {
        q: "Does the organized day trip incur any charge?",
        a: "<span>Yes, the organized day trips may incur additional charges, but they are a great way to explore the UK and Ireland.</span>",
      },
      {
        q: "What kind of housing assistance do you provide?",
        a: "<span>We offer guidance on affordable, student friendly accommodation assistance. Apart from that, we also offer guarantor support.</span>",
      },
      {
        q: "What is a guarantor?",
        a: "<span>A guarantor is a person that agrees to be responsible for the financial obligations of a person usually in a rental agreement. Landlords often require students to have a guarantor since they typically do not have a steady income</span>",
      },
      {
        q: "How can you assist me with my student visa application?",
        a: "<span>Our team will mentor you through the entire visa application process, making your experience smooth by providing you with information and support</span>",
      },
      {
        q: "What is the cashback on university fee remittances?",
        a: "<span>Explorers can get up to £60 and Globetrotters can get up to £120 when you remit your university fees through our services</span>",
      },
      {
        q: "What is university fees remittance?",
        a: "<span>It refers to the process of paying tuition and other associated fees to a university or educational institution</span>",
      },
      {
        q: "Do I need to pay to attend the international festival celebrations?",
        a: "<span>Some festivals might have a small fee, but we’ll always keep costs affordable.</span>",
      },
    ],
  };

  const membership = [
    {
      label: "Curated list of Part-time and Full-time job openings",
      explorer: true,
      globetrotter: true,
      description:
        "Managing expenses while studying abroad can be challenging. Which is why we provide a curated list of part-time jobs suitable specifically for International Students! You’ll gain access to top openings that fit your study schedule, making it easier to earn while studying. And our support doesn’t stop there; we’re also here to help you secure your dream job—whether part-time or full-time",
      color_code: "#FFF5F0",
    },
    {
      label: "Personalised career development workshops",
      explorer: false,
      globetrotter: true,
      description:
        "Struggling to navigate the job market and secure a position in your field? Our regular and in-person career development sessions, led by experts, offer the guidance and support you need to succeed",
      color_code: "#FFFFFF",
    },
    {
      label: "Networking events with sponsored visa graduates",
      explorer: false,
      globetrotter: true,
      description:
        "Concerned about landing a full-time job with sponsorship? Gain access to exclusive networking events with graduates who have successfully secured full-time positions with sponsorship! Learn invaluable tips and tricks to get ahead of the competition.",
      color_code: "#FFC7A1",
    },
    {
      label: "Legal opinion on U.K contracts",
      explorer: false,
      globetrotter: true,
      description:
        "Confused by the legal jargon, whether for rental agreements or for part-time/ full-time offers? While you can ask ChatGpt for help, but how about consulting a qualified legal professional to explain any terms or restrictions you’re unsure about. Our in-house legal experts are available to clarify any doubts you may have, so you can sign with confidence",
      color_code: "#FFF5F0",
    },
    {
      label: "Discounted Flight tickets on British Airways flights",
      explorer: true,
      globetrotter: true,
      description:
        "With flight prices soaring whenever you have a break at Uni - it’s a daunting task to plan your trip abroad! We can help take away some of that pain by getting you discounted flight tickets through our partnerships!",
      color_code: "#FFFFFF",
    },
    {
      label: "Organised Day Trips to major attractions in the U.K and Ireland",
      explorer: true,
      globetrotter: true,
      description:
        "Are you new to the country and excited to explore its major attractions but concerned about high costs?  We’ve got you covered with organized day trips to iconic sites such as Stonehenge, the Salisbury Cathedral (home of Magna Carta), Brighton beach, and The White Cliffs of Dover - all within easy reach of London. Or if you’re studying near London, enjoy a day trip to the city to see landmarks like Tower of London, Tower Bridge, Big Ben, Westminster, London Eye and many more - all as part of an affordable package, with the company of other international students.",
      color_code: "#FFC7A1",
    },
    {
      label: "Outstation Group Tours",
      explorer: true,
      globetrotter: true,
      description:
        "Planning a weekend getaway but unsure about the logistics? We offer curated itineraries for top UK destinations such as Edinburgh (go a little further, and you might spot the Loch Ness monster!) and Liverpool (the birthplace of The Beatles, where You’ll Never Walk Alone), all designed with international students in mind and tailored to suit your budget.",
      color_code: "#FFF5F0",
    },
    {
      label: "Couch & Coffee- Up to 2 nights stay anywhere in UK & Ireland",
      explorer: false,
      globetrotter: true,
      description:
        "Want to visit a UK city or university town but don’t know anyone there? Hotels can be expensive but our exclusive C&C (move aside AirBnB!), available for established Globetrotter members, provides an affordable alternative. You can stay up to two nights in student accommodation offered by our trusted mentors, in UK and Ireland for a nominal fee. Please note that this is subject to availability and terms and conditions apply. While a five-star breakfast isn’t included, a cup of coffee/tea can be availed. (or While a five-star breakfast isn’t included, coffee and tea certainly are).",
      color_code: "#FFFFFF",
    },
    {
      label: "Visa and immigration information",
      explorer: false,
      globetrotter: true,
      description:
        "Be it student visa or travel visa; Navigating the application process can be a huge headache. Leave it to us; we’ll mentor you through securing your visa.",
      color_code: "#FFC7A1",
    },
    {
      label: "Social events",
      explorer: true,
      globetrotter: true,
      description:
        "Feeling disconnected or missing the sense of belonging? Join our community events where you can meet fellow international students, share experiences and spend some time together. It’s the perfect way to build lasting friendships and feel more at home while studying abroad!",
      color_code: "#FFF5F0",
    },
    {
      label: "International Festivals celebration",
      explorer: true,
      globetrotter: true,
      description:
        "Feeling homesick during the festive season? Whether it’s Diwali, Chinese New Year, Holi or any other festival, we’ll bring the traditional celebrations to you, so you never feel far from home.",
      color_code: "#FFFFFF",
    },
    {
      label: "Cashback on Uni Fee Remittances",
      explorer: true,
      globetrotter: true,
      description:
        "Spend, spend, spend - life in the UK is costly (ouch!), but how about if you could earn something back on your biggest expenditure? Earn up to £60 (Explorer) / £120 (Globetrotter) per year on your university fee remittances. University fee remittances can be costly, but with us, you can earn cashback - up to £60 per year as an Explorer or £120 as Globetrotter.",
      color_code: "#FFC7A1",
    },
    {
      label: "Top discounts and deals",
      explorer: true,
      globetrotter: true,
      description:
        "Do you spend precious time clipping coupons, or scrolling websites for the best “deals”? Finding affordable options can be tough as a student, be it while shopping or getting groceries, but we’ve got your back with top discounts and deals across a wide range of products.",
      color_code: "#FFF5F0",
    },
    {
      label: "Housing assistance and guarantor support",
      explorer: false,
      globetrotter: true,
      description:
        " Is your landlord asking for a guarantor or six months’ rent upfront, and it’s just not affordable? Look to us for housing help, and we can provide the guarantor support you need! And that’s not all – we’ll also help you find your next home!",
      color_code: "#FFFFFF",
    },
    {
      label: "Exclusive Merchandise giveaways",
      explorer: false,
      globetrotter: true,
      description:
        "Who doesn’t love free stuff? Enjoy exclusive merchandise such as hoodies, keychains, tote bags and more!",
      color_code: "#FFC7A1",
    },
    // {
    //   label: "Discounted Flight tickets (British Airways)",
    //   explorer: false,
    //   globetrotter: true,
    //   color_code: "#FFF5F0",
    // },
    // {
    //   label: "Social Connections",
    //   explorer: true,
    //   globetrotter: true,
    //   color_code: "#FFFFFF",
    // },
    // {
    //   label: "Movie nights – One FREE movie outing, each month*",
    //   explorer: false,
    //   globetrotter: true,
    //   color_code: "#FFC7A1",
    // },
    // {
    //   label: "Exclusive Merchandise giveaways",
    //   explorer: false,
    //   globetrotter: true,
    //   color_code: "#FFF5F0",
    // },
    // {
    //   label: "Gym Memberships – Coming soon",
    //   explorer: false,
    //   globetrotter: false,
    //   color_code: "#DBDBDB",
    // },
    // {
    //   label: "Student Credit Card – Coming soon ",
    //   explorer: false,
    //   globetrotter: false,
    //   color_code: "#EDEDED",
    // },
    // {
    //   label: "Buddy-Up for travel – Coming soon",
    //   explorer: false,
    //   globetrotter: false,
    //   color_code: "#DBDBDB",
    // },
  ];

  const toggleShowAll = () => {
    if (isHomePage) {
      navigate("/membership");
    }
  };

  const handlePurchaseProduct = (type) => {
    const fetchProductData = isLoggedIn ? getProducts : getProductData;
    if (type === "isComplimentary") {
      fetchProductData("Membership")
        .then((response) => {
          const data = response.find((x) => x.isComplimentary);
          console.log(data, "data");
          dispatch(setCheckoutType(true));
          dispatch(setProductData(data));
          if (isLoggedIn) {
            navigate("/checkout-preview");
          } else {
            dispatch(setModalOpen(true));
            dispatch(setCurrentForm("signIn"));
            dispatch(setCheckoutType(true));
            dispatch(setIsCheckoutToShow(true));
          }
        })
        .catch((error) => console.log(error));
    } else {
      fetchProductData("Membership")
        .then((response) => {
          const data = response.find((x) => !x.isComplimentary);
          dispatch(setCheckoutType(true));
          dispatch(setProductData(data));
          if (isLoggedIn) {
            navigate("/checkout-preview");
          } else {
            dispatch(setModalOpen(true));
            dispatch(setCurrentForm("signIn"));
            dispatch(setCheckoutType(true));
            dispatch(setIsCheckoutToShow(true));
            dispatch(setProductData(data));
          }
        })
        .catch((error) => console.log(error));
    }
  };

  const handlePopover = (content) => {
    dispatch(setModalOpen(true));
    dispatch(setCurrentForm("membershipDescription"));
    dispatch(
      setFormProps({
        message: content,
      })
    );
  };

  return (
    <div className="membership-wrapper">
      <div className="membership-container">
        <div className="heading-wrapper">
          <div className="heading">Memberships for Current Students</div>
          <div className="subheading">
            <span>Are you in UK or Ireland ? Become a Globetrotter with</span>
            <br />
            <span>us to unleash the full power of your community.</span>
          </div>
        </div>
        <div className="membership-grid">
          <div className="membership-header-label member-cell sticky-grid  ffc7a1">
            Features of these membership tiers:
          </div>
          <div className="membership-header-label member-cell content-center content-coloum ffc7a1">
            <img
              src="/assets/images/membership_explorer.png"
              alt="Explorer"
              className="img_explorer"
            />
            <span>Explorer</span>
          </div>
          <div className="membership-header-label member-cell content-center content-coloum ffc7a1">
            <img
              src="/assets/images/membership_globetrotter.png"
              alt="Globetrotter"
              className="img_globetrotter"
            />
            <span>Globetrotter</span>
          </div>
          {(!isHomePage ? membership : membership.slice(0, 10))?.map((item, index) => {
            return (
              <Fragment key={index}>
                <div className={`member-cell sticky-grid ${item.color_code.replace("#", "")} `}>
                  <span>{item.label}</span>
                  {window.innerWidth < 425 ? (
                    <span onClick={() => handlePopover(item.description)}>
                      <IconInfo />
                    </span>
                  ) : (
                    <Popover
                      placement="bottomRight"
                      content={
                        <div
                          style={{
                            maxWidth: window.innerWidth < 768 ? "30vh" : "40vh",
                          }}
                        >
                          {item.description}
                        </div>
                      }
                      trigger="hover"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <IconInfo />
                    </Popover>
                  )}
                </div>
                <div className={`member-cell content-center ${item.color_code.replace("#", "")} `}>
                  {item.explorer ? <IconTick /> : <IconMinus />}
                </div>
                <div className={`member-cell content-center ${item.color_code.replace("#", "")}`}>
                  {item.globetrotter ? <IconTick /> : <IconMinus />}
                </div>
              </Fragment>
            );
          })}
          {!isHomePage ? (
            <>
              <div className={`member-cell sticky-grid FFF5F0`}></div>
              <div className={`member-cell content-center FFF5F0 `}>
                <ButtonComponent
                  label="Join For Free"
                  size="medium"
                  onClick={() => handlePurchaseProduct("isComplimentary")}
                />
              </div>
              <div className={`member-cell content-center FFF5F0`}>
                <ButtonComponent
                  label="Buy Now"
                  size="medium"
                  onClick={() => handlePurchaseProduct("university")}
                />
              </div>
            </>
          ) : (
            <></>
          )}
          {/* <div className="membership-grid w-100">
          <div></div>
          <img
            src="/assets/images/membership_explorer.png"
            alt="Explorer"
            className="img_explorer"
          />
          <img
            src="/assets/images/membership_globetrotter.png"
            alt="Globetrotter"
            className="img_globetrotter"
          />
        </div> */}
        </div>

        {/* {(showAll ? membership : membership.slice(0, 10)).map((item, index) => (
                <Row key={index} className="membership-row" style={{ backgroundColor: item.color_code }}>
                    <Col span={12} className="membership-label">
                        {item.label}
                    </Col>

                    <Col span={6} className="membership-status" style={{ position: 'relative', paddingRight: '10px' }}>
                        {item.explorer ? <IconTick /> : <IconMinus />}
                        <div style={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            height: '100%',
                            width: '1px',
                            backgroundColor: '#000'
                        }}></div>
                    </Col>

                    <Col span={6} className="membership-status" style={{ paddingLeft: '10px' }}>
                        {item.globetrotter ? <IconTick /> : <IconMinus />}
                    </Col>
                </Row>
            ))} */}
        {isHomePage ? (
          <div div type="link" onClick={toggleShowAll} className="view-more">
            <div>
              <label>View more features</label>
              <IconViewMore />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>

      {!isHomePage ? (
        <>
          <div className="membership-details">
            <div className="title-h5-1">
              There are two membership options available for students as of now:
            </div>
            <div className="body-b4">
              Basic - <b>Explorer</b> - The Explorer membership is designed for students who want to
              get a head start on their study abroad adventure. Enjoy access to curated job
              opportunities (whether part-time or full-time), exclusive community events, discounted
              flight tickets and much more! Explorer gives you the essentials to kick off your
              overseas education journey - for free! In fact we give you the chance to win cash-back
              on your Uni Fee remittances!
            </div>
            <div className="body-b4">
              Premium - <b>Globetrotter</b> - The Globetrotter membership offers premium benefits
              tailored to your academic and career development needs, on top of all the benefits
              that are available in the Explorer membership. Enjoy exclusive career workshops,
              connect with sponsored visa graduates at networking events, and receive assistance
              with housing and visa matters. This membership ensures you have comprehensive support
              throughout your study abroad experience. Become a Globetrotter today and unlock a
              variety of exclusive perks!
            </div>
          </div>
          <div className="faq-wrapper">
            <div className="heading title-h5-1">{FAQ.heading}:</div>
            <Collapse
              accordion
              expandIcon={customExpandIcon}
              expandIconPosition="right"
              className="accordion"
            >
              {FAQ.accordion.map((item, index) => {
                return (
                  <Fragment key={index + 1}>
                    <Panel header={`${index + 1 + ". "}${item.q}`} key={index + 1}>
                      <div className="content">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.a,
                          }}
                        />
                      </div>
                    </Panel>
                  </Fragment>
                );
              })}
            </Collapse>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Membership;
